<template>
  <div>
    <el-table
      v-if="viewFlag"
      :data="notPayommissionList"
      tooltip-effect="dark"
      style="margin:auto;margin-bottom:50px;"
    >
      <!-- 上课日期时间 -->
      <el-table-column
        prop="dateAndTime"
        :label="$t('p0416.dateTime')"
        align="center"
        min-width="70"
        :formatter="createTimeFormat"
      ></el-table-column>
      <!-- 课程编号 -->
      <el-table-column
        prop="courseNumberView"
        :label="$t('p0416.courseNumber')"
        align="center"
        min-width="50"
      ></el-table-column>
      <!-- 课程名称 -->
      <el-table-column
        prop="courseName"
        :label="$t('p0416.courseName')"
        align="left"
        min-width="150"
      ></el-table-column>
      <!-- 佣金总额 -->
      <el-table-column
        prop="totalCommission"
        :label="$t('p0416.totalCommission')"
        align="center"
        min-width="60"
      ></el-table-column>
      <!-- 已付金额 -->
      <el-table-column
        prop="payCommission"
        :label="$t('p0416.amountPaid')"
        align="center"
        min-width="60"
      >
      </el-table-column>
      <!-- 货币 -->
      <el-table-column
        prop="currencyView"
        :label="$t('p0416.currency')"
        align="center"
        min-width="40"
      >
      </el-table-column>
      <!-- 操作 -->
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope">
          <el-button size="text" @click="getDetails(scope.row)">{{
            $t("p0416.details")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 课程结算详情 -->
    <p0419
      ref="p0419"
      :detailList="detailList"
      @getViewFlag="getViewFlag"
      v-if="!viewFlag"
    ></p0419>
  </div>
</template>

<script>
import qs from "qs";
import p0419 from "../../Marketing/CouponCode/P0419";
import moment from "moment";
export default {
  components: {
    p0419
  },
  data() {
    return {
      detailList: [],
      // 显示画面标志
      viewFlag: true,
      notPayommissionList: []
    };
  },
  methods: {
    // 查询明细
    getDetails(row) {
      // console.log(row);
      // 显示课程结算信息
      this.viewFlag = false;
      // 传递课程数据
      this.detailList = row;
    },
    // 控制显示
    getViewFlag(data) {
      this.viewFlag = data;
      this.getPayCommissionList();
    },
    //创建日期格式化时间
    createTimeFormat(row) {
      if (row.dateAndTime != null && row.dateAndTime != "") {
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    // 初始化数据
    getPayCommissionList() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/greenJacketOrder/getPayCommissionList";
      this.$http
        .get(url)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.notPayommissionList = response.data.data;
            console.log(
              "🚀 ~ file: P0414.vue:141 ~ getPayCommissionList ~ response.data.data",
              response.data.data
            );
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    }
  },
  mounted() {
    this.getPayCommissionList();
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0417.vue